"use client";

import { datadogLogs } from "@datadog/browser-logs";
import { DataDogBrowserLogsTransport } from "@loglayer/transport-datadog-browser-logs";
import { getSimplePrettyTerminal } from "@loglayer/transport-simple-pretty-terminal";
import { LogLayer } from "loglayer";
import { serializeError } from "serialize-error";
import { shouldDiscardBrowserLog } from "~/lib/datadog/telemetryFilters";

const isProduction = process.env.NODE_ENV === "production";

// Initialize Datadog Browser Logs SDK in production
if (
	isProduction &&
	typeof window !== "undefined" &&
	process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
) {
	datadogLogs.init({
		clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
		site: "datadoghq.eu",
		service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
		env: process.env.NEXT_PUBLIC_DATADOG_ENV,
		version: process.env.NEXT_PUBLIC_GIT_TAG,
		sessionSampleRate: 100,
		beforeSend: (log) => !shouldDiscardBrowserLog(log),
	});
}

const clientLogger = new LogLayer({
	errorSerializer: serializeError,
	transport: [
		// Pretty terminal logging for development
		getSimplePrettyTerminal({
			enabled: !isProduction,
			runtime: "browser",
			viewMode: "inline",
		}),
		// Datadog Browser Logs transport for production
		new DataDogBrowserLogsTransport({
			enabled:
				isProduction &&
				typeof window !== "undefined" &&
				!!process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
			logger: datadogLogs.logger,
		}),
	],
});

// Add client context
clientLogger.withContext({
	runtime: "client",
	env: process.env.NEXT_PUBLIC_DATADOG_ENV || process.env.NODE_ENV,
	version: process.env.NEXT_PUBLIC_GIT_TAG,
	service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
});

export function getClientLogger() {
	return clientLogger;
}
